const initialState = () => ({
  forms: [],
  locations: [],
  selectedForm: null,
  selectedBlock: null,
  fillBlock: false,
  isOpeningOccurrence: false,
  assignmentsRoles: [],
  locationFilter: { folio: '', locationIds: [] }
})

export default initialState
